import { Link } from 'react-router-dom';
import { Instagram, Phone, MapPin, Mail, ShieldCheck } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-brand-dark text-white relative z-10">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          
          {/* Brand & Logo (Filtreler Silindi - Test Modu) */}
          <div className="md:col-span-1 flex flex-col items-start">
            <Link to="/" className="inline-block mb-6 transition-transform duration-300 hover:scale-105">
              <img 
                src="/favicon.png" 
                alt="Ayz Plastik Logo" 
                className="h-14 w-auto drop-shadow-lg"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed font-medium">
              Kalitenin adı. Plastik sektöründe modern ve estetik çözümler sunuyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-[10px] uppercase tracking-[0.2em] text-white/30 mb-6">
              Sayfalar
            </h4>
            <ul className="space-y-4">
              {[
                { to: '/', label: 'Ana Sayfa' },
                { to: '/urunler', label: 'Ürünler' },
                { to: '/hakkimizda', label: 'Hakkımızda' },
                { to: '/katalog', label: 'Katalog' },
                { to: '/iletisim', label: 'İletişim' },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/60 hover:text-white text-sm font-medium transition-colors duration-200 flex items-center gap-2 group"
                  >
                    <span className="w-0 h-[1px] bg-white transition-all duration-300 group-hover:w-3"></span>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact (Bilgiler güncel) */}
          <div>
            <h4 className="font-bold text-[10px] uppercase tracking-[0.2em] text-white/30 mb-6">
              İletişim
            </h4>
            <ul className="space-y-5">
              <li className="flex items-start gap-3 group">
                <Phone size={18} className="text-brand-blue group-hover:text-white transition-colors shrink-0" />
                <a href="tel:+905542345454" className="text-white/60 hover:text-white text-sm font-medium transition-colors">
                  0554 234 54 54
                </a>
              </li>
              <li className="flex items-start gap-3 group">
                <Mail size={18} className="text-brand-pink group-hover:text-white transition-colors shrink-0" />
                <a href="mailto:ayzplastik@gmail.com" className="text-white/60 hover:text-white text-sm font-medium transition-colors">
                  ayzplastik@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 group">
                <MapPin size={18} className="text-brand-blue group-hover:text-white transition-colors shrink-0" />
                <span className="text-white/60 text-sm font-medium">
                  Konya, Türkiye
                </span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-bold text-[10px] uppercase tracking-[0.2em] text-white/30 mb-6">
              Takip Edin
            </h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/ayzplastik?igsh=MWJ6c2djYTdoeTVhag%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:bg-brand-pink hover:text-white hover:border-brand-pink transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://wa.me/905542345454"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:bg-green-500 hover:text-white hover:border-green-500 transition-all duration-300"
              >
                <Phone size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col gap-8 md:gap-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            
            {/* Sol Taraf: Telif Hakkı ve May Plastik Bildirimi */}
            <div className="flex flex-col items-center md:items-start gap-4 text-center md:text-left">
              <p className="text-white/40 text-xs font-medium">
                &copy; {new Date().getFullYear()} Ayz Plastik. Tüm hakları saklıdır.
              </p>
              
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/5 text-white/40 text-[10px]">
                <ShieldCheck size={14} className="text-brand-blue/70 shrink-0" />
                <span>
                  <strong className="text-white/60 font-bold tracking-wide">Ayz Plastik</strong>, yetkili bir <strong className="text-white/60 font-bold tracking-wide">May Plastik</strong> satış kanalıdır.
                </span>
              </div>
            </div>
            
            {/* Sağ Taraf: İyzico Yasal Linkleri ve Admin */}
            <div className="flex flex-col items-center md:items-end gap-5 text-center md:text-right">
              
              {/* İyzico'nun Aradığı Yasal Linkler Navigasyonu */}
              <nav className="flex flex-wrap justify-center md:justify-end items-center gap-x-4 gap-y-2 text-[11px] font-medium text-white/40">
                <Link to="/yasal-metinler" className="hover:text-white transition-colors duration-300">
                  Mesafeli Satış Sözleşmesi
                </Link>
                <Link to="/yasal-metinler" className="hover:text-white transition-colors duration-300">
                  İptal ve İade Koşulları
                </Link>
                <Link to="/yasal-metinler" className="hover:text-white transition-colors duration-300">
                  Gizlilik Politikası
                </Link>
                <Link to="/yasal-metinler" className="hover:text-white transition-colors duration-300">
                  Teslimat Koşulları
                </Link>
              </nav>

              <Link
                to="/admin"
                className="text-white/20 hover:text-white/60 text-[10px] font-bold uppercase tracking-widest transition-colors duration-200 shrink-0"
              >
                Admin Paneli
              </Link>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
}